<template>
  <svg width="12"
       height="13"
       viewBox="0 0 12 13"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M0.313608 10.9346C-0.0555325 11.3037 -0.0731106 11.9629 0.322397 12.3408C0.700327 12.7363 1.3683 12.7188 1.73744 12.3496L6.00013 8.08691L10.2628 12.3496C10.6408 12.7275 11.2911 12.7363 11.6691 12.3408C12.0646 11.9629 12.0558 11.3037 11.6779 10.9258L7.41517 6.66309L11.6779 2.40918C12.0558 2.02246 12.0646 1.37207 11.6691 0.994141C11.2911 0.598633 10.6408 0.607422 10.2628 0.985352L6.00013 5.24805L1.73744 0.985352C1.3683 0.616211 0.700327 0.598633 0.322397 0.994141C-0.0731106 1.37207 -0.0555325 2.03125 0.313608 2.40039L4.5763 6.66309L0.313608 10.9346Z"
          :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'CloseIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
